import React from 'react'
import { components } from 'cng-web-lib'
import PersonDocumentDTOFormProperties from './PersonDocumentDTOFormProperties'
import { Grid, Tooltip } from '@material-ui/core'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngIconButton }
} = components

const { initialValues } = PersonDocumentDTOFormProperties.formikProps

function PersonDocumentDTOEntry(props) {
  const {
    index,
    personIndex,
    isLast,
    onAddPersonDocumentDTO,
    onDeletePersonDocumentDTO,
    personDocumentDTO,
    showNotification
  } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md>
        <PersonDocumentDTOFormProperties.Fields index={index} showNotification={showNotification} personIndex={personIndex} personDocumentDTO={personDocumentDTO}/>
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.addNewLabel}>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddPersonDocumentDTO(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.cloneLabel}>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddPersonDocumentDTO({ ...personDocumentDTO, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title={aciHighwayManifestTranslationText.deleteLabel}>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeletePersonDocumentDTO(personDocumentDTO)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PersonDocumentDTOEntry
